// SampleOrdersModal.js
import React from "react";
import { Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";

const SampleOrdersModal = ({
  isOpen,
  toggle,
  sampleOrders,
  loadingProjectId,
  handleTryNowClick,
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl">
      <ModalHeader toggle={toggle}>Sample Orders</ModalHeader>
      <ModalBody>
        <div className="container">
          <div className="row">
            {sampleOrders.map((project) => (
              <div
                className="col-12 col-md-4 d-flex flex-column align-items-center mb-4"
                key={project.id}
              >
                <img
                  src={project.image}
                  alt={project.name}
                  className="mb-2"
                  style={{
                    height: "300px",
                    width: "300px",
                    objectFit: "cover",
                  }}
                />
                <div className="fw-bold mb-2 text-center">{project.name}</div>
                <button
                  className="btn btn-outline-primary"
                  disabled={loadingProjectId === project.id}
                  onClick={() => handleTryNowClick(project.id, project.name)}
                >
                  {loadingProjectId === project.id ? (
                    <Spinner size="sm" />
                  ) : (
                    "Try Now"
                  )}
                </button>
              </div>
            ))}
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default SampleOrdersModal;
